import React from 'react';
import { Timeline } from 'tea-component';
import './index.scss';
import moment from 'moment';

interface timelineInfo {
  // 时间戳字符串
  date: string;
  info: string;
  version: string;
}

interface propsInfo {
  // 时间轴的信息
  timelines: timelineInfo[];
  // 显示的时间格式
  format?: string;
  noDataTip?: string;
}

export default function TimelineContext(props: propsInfo) {
  const { timelines = [], format = 'yyyy.MM.DD', noDataTip } = props;

  return (
    <div className="dbi-timeline-context">
      {timelines?.length > 0 ? <Timeline className="timeline-style">
        {
          timelines?.map((item, index: number) => {
            const { date, info } = item;
            const _date = moment(date).format(format);
            return (
              <Timeline.Item
                key={index}
                label={<div
                  className="timeline-style-text"
                  dangerouslySetInnerHTML={{ __html: info }}
                ></div>}
              >
                {_date}
              </Timeline.Item>
            );
          })
        }
      </Timeline> : <div className="nodata-center">{noDataTip}</div>
      }
    </div>
  );
}

